import script from "./GestaoDeEquipe.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoDeEquipe.vue?vue&type=script&setup=true&lang=js"

import "./GestaoDeEquipe.vue?vue&type=style&index=0&id=299777cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299777cb"]])

export default __exports__